/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import TaskNotificationScreen from '@/screens/task-notification/TaskNotificationScreen';
import TaskNotificationDetailScreen from '@/screens/task-notification/TaskNotificationDetailScreen';

const Stack = createStackNavigator();

const TaskNotificationNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="TaskNotificationScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="TaskNotificationScreen"
        component={TaskNotificationScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Notifications';
          if (route.params && route.params.task) {
            title = 'Task';
          }
          return {
            title: setTitleHeader(title),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="TaskNotificationDetailScreen"
        component={TaskNotificationDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                customBack={{
                  screen: 'TaskNotificationScreen',
                  params: { task: true },
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default TaskNotificationNavigator;
